import React from 'react';
import PropTypes from 'prop-types';
import tripAdvisorIcon from './icon-trip-advisor.png';
import googleReviewsIcon from './icon-google-reviews.png';
import './index.scss';

/*
 * Types definition
 */
const propTypes = {
    tripAdvisorUrl: PropTypes.string,
    googleReviewsUrl: PropTypes.string,
    label: PropTypes.string,
};

const defaultProps = {
    tripAdvisorUrl: '',
    googleReviewsUrl: '',
    label: 'read this store’s reviews now',
};

/*
 * Component
 */
function Reviews({ tripAdvisorUrl, googleReviewsUrl, label }) {
    if (!tripAdvisorUrl && !googleReviewsUrl) {
        return null;
    }

    return (
        <div className="reviews">
            <div className="icons">
                {tripAdvisorUrl
                && (
                    <a href={tripAdvisorUrl} target="_blank" rel="noopener noreferrer">
                        <img src={tripAdvisorIcon} alt="" />
                    </a>
                )}
                {googleReviewsUrl
                && (
                    <a href={googleReviewsUrl} target="_blank" rel="noopener noreferrer">
                        <img src={googleReviewsIcon} alt="" />
                    </a>
                )}
            </div>
            <span className="label">{label}</span>
        </div>
    );
}

Reviews.propTypes = propTypes;
Reviews.defaultProps = defaultProps;

export default Reviews;
